export default function AnnouncementSettings() {
  return (
    <div style={{ padding: 16 }}>
      <h3>Announcement Settings</h3>
      <p>Configure announcement behavior here.</p>
    </div>
  );
}
